import { Injectable } from '@angular/core';

type NavigationGuardHandler = () => boolean | Promise<boolean>;
type ShowDialogHandler = () => Promise<boolean>;

@Injectable()
export class NavigationGuardService {
	private shouldBlockHandler: NavigationGuardHandler = () => false;
	private showDialogHandler: ShowDialogHandler | null = null;

	public setGuard(shouldBlockHandler: NavigationGuardHandler): void {
		this.shouldBlockHandler = shouldBlockHandler;
	}

	public setShowDialogHandler(handler: ShowDialogHandler): void {
		this.showDialogHandler = handler;
	}

	public clearGuard(): void {
		this.shouldBlockHandler = () => false;
		this.showDialogHandler = null;
	}

	/**
	 * For async navigation blocking (Angular router)
	 * Shows the React dialog and waits for user decision
	 */
	public async canNavigate(): Promise<boolean> {
		const shouldBlock = this.shouldBlockHandler();
		const blockValue = shouldBlock instanceof Promise ? await shouldBlock : shouldBlock;

		if (!blockValue) {
			return true; // Don't block
		}

		// Block is active, show dialog if handler is available
		if (this.showDialogHandler) {
			return await this.showDialogHandler();
		}

		// Fallback: if no dialog handler, don't block
		return true;
	}

	/**
	 * For sync navigation blocking (beforeunload)
	 * Returns boolean where true = should block navigation
	 */
	public shouldBlock(): boolean {
		const result = this.shouldBlockHandler();
		if (result instanceof Promise) {
			return true;
		}
		return result;
	}
}
